module.exports = __webpack_public_path__ + "img/iib_logo_eng2.b812ab4b.png";